export default __webpack_public_path__ + "7d990af94a3e0e8021060534d4d899d1.png";